<template>
  <div>
    <div class="f-search-block">
      <el-form
        ref="formInline"
        :inline="true"
        :model="formInline"
      >
        <el-form-item
          label="活动名称"
          prop="activity_name"
        >
          <el-input
            v-model="formInline.activity_name"
            placeholder="请输入活动名称"
          />
        </el-form-item>
        <el-form-item
          label="创建日期"
          prop="dateRange"
        >
          <el-date-picker
            v-model="formInline.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >
          查询
        </el-button>
        <!-- <el-form-item label="活动状态" prop="status">
          <el-select v-model="formInline.status" placeholder="请选择活动状态">
            <el-option label="未开始" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
            <el-option label="已删除" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启动状态" prop="startStatus">
          <el-select v-model="formInline.startStatus" placeholder="请选择启动状态">
            <el-option label="全部" value="0"></el-option>
            <el-option label="已启用" value="1"></el-option>
            <el-option label="已关闭" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-row>
          <el-button @click="resetForm('formInline')">重置</el-button>
        </el-row> -->
      </el-form>
    </div>
    <div class="f-table-block">
      <el-button
        type="primary"
        @click="handleJumpNew(0)"
      >
        创建活动
      </el-button>

      <el-tabs
        v-model="activeIndex"
        @tab-click="handleSelect"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>
      <el-container>
        <el-row
          v-if="list && list.length > 0"
          class="block"
        >
          <el-row :gutter="10">
            <el-col
              v-for="(item, index) in list"
              :key="index"
              :xs="12"
              :sm="8"
              :md="6"
              :lg="4"
              class="mb10"
              style="min-width: 200px; min-height: 410px"
            >
              <div :body-style="{ padding: '0px' }">
                <div class="card">
                  <div
                    class="content"
                    @click="showCode(item)"
                  >
                    <el-row
                      type="flex"
                      justify="center"
                    >
                      <div
                        class="image-box"
                        :style="{ backgroundImage: 'url(' + item.image_cover + ')' }"
                      />
                    </el-row>
                    <!-- <div class="hover-content" @click="showCode(item)">
                      <el-row type="flex" justify="center">
                        <i class="el-icon-view icon-view"></i>
                        <span class="fs16">预览活动</span>
                      </el-row>
                    </div> -->
                  </div>

                  <!-- <div class="time" v-if="item.begin_time && item.begin_time">
                    {{ item.begin_time }} 至 {{ item.end_time }}
                  </div> -->
                  <div
                    class="time"
                    @click="showCode(item)"
                  >
                    点击预览
                  </div>
                  <div class="mid">
                    <div class="status_info">
                      <el-tag
                        :type="statusName[item.status].className"
                        size="mini"
                      >
                        {{
                          statusName[item.status].statusSwitch
                        }}
                      </el-tag>
                      <!-- <el-tag type="danger" effect="plain"> 立即结束 </el-tag> -->
                      <span
                        v-if="item.status === 0 || item.status === 1"
                        class="end"
                        @click="handleEnd(item)"
                      >立即结束</span>
                    </div>
                    <div class="title">
                      {{ item.activity_name }}
                    </div>
                    <div class="join">
                      <el-tag
                        v-if="item.submit_count"
                        size="mini"
                      >
                        参与人数 {{ item.submit_count }}
                      </el-tag>
                      <div
                        v-else
                        class="tac"
                      >
                        <br>
                      </div>
                    </div>
                    <!-- <div v-if="item.submit_count" class="tac join"></div> -->
                    <div
                      v-if="item.begin_time"
                      class="tac"
                    >
                      开始时间 {{ item.begin_time }}
                    </div>
                    <div
                      v-if="item.end_time"
                      class="tac"
                    >
                      结束时间 {{ item.end_time }}
                    </div>
                    <div
                      v-if="!item.end_time && !item.end_time"
                      class="tac long_term"
                    >
                      长期有效
                    </div>
                  </div>

                  <div
                    class="footer"
                    @click="handlePost(item)"
                  >
                    <div class="footer-item">
                      <i class="el-icon-tickets" />&nbsp;按渠道投放活动
                    </div>
                  </div>
                  <div class="footer">
                    <div
                      class="footer-item"
                      @click="handleJumpNew(item.activity_id)"
                    >
                      <i class="el-icon-edit" /> 编辑
                    </div>
                    <div
                      class="footer-item"
                      @click="handleCopy(item)"
                    >
                      <i class="el-icon-document-copy" /> 复制
                    </div>
                    <div
                      class="footer-item"
                      @click="handleJumpData(item.activity_id)"
                    >
                      <i class="el-icon-s-data" /> 数据
                    </div>
                  </div>
                  <div
                    v-if="item.isShowCode"
                    class="preview"
                  >
                    <div class="preview-code">
                      <el-row
                        type="flex"
                        justify="end"
                      >
                        <div class="close-btn">
                          <i
                            class="el-icon-circle-close fs16"
                            @click="hideCode(item)"
                          />
                        </div>
                      </el-row>
                      <el-row
                        type="flex"
                        justify="center"
                      >
                        <img
                          :src="item.share_qrcode"
                          class="code"
                        >
                      </el-row>
                      <el-row
                        type="flex"
                        justify="center"
                      >
                        <el-col :span="24">
                          <div class="tips">
                            手机扫描查看/预览活动
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-row>
        <el-row
          v-else
          type="flex"
          justify="center"
        >
          <el-col :span="24">
            <span class="no-data">暂无数据</span>
          </el-col>
        </el-row>
      </el-container>

      <el-pagination
        class="table-pagination"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-row
        type="flex"
        justify="end"
      >
        <el-col :span="24">
          <div class="tips">
            查看/预览活动
          </div>
        </el-col>
      </el-row>

      <el-row
        type="flex"
        justify="center"
      >
        <img
          :src="share_qrcode"
          class="code"
        >
      </el-row>
      <el-row
        type="flex"
        justify="center"
      >
        <el-col :span="24">
          <div class="tips">
            手机扫描查看/预览活动
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 分享活动 -->
    <ShareActivity
      :share-activity-visible="shareActivityVisible"
      :share-activity-data="shareActivityData"
      @shareActivityVisibleChange="shareActivityVisibleChange"
    />

    <!-- 投放活动 -->
    <PostActivity
      :post-activity-visible="postActivityVisible"
      :post-activity-data="postActivityData"
      @postActivityVisibleChange="postActivityVisibleChange"
    />
  </div>
</template>

<script>
import ShareActivity from '@/components/formActivity/shareActivity'
import PostActivity from '@/components/formActivity/postActivity'
import moment from 'moment'

export default {
  components: {
    ShareActivity,
    PostActivity
  },
  data () {
    return {
      tabList: [
        { name: '-1', label: '全部' },
        { name: '1', label: '进行中' },
        { name: '0', label: '未开始' },
        { name: '2', label: '已结束' }
      ],
      statusName: {
        0: {
          className: '',
          statusSwitch: '未开始'
        },
        1: {
          className: 'success',
          statusSwitch: '进行中'
        },
        2: {
          className: 'info',
          statusSwitch: '已结束'
        },
        3: {
          className: 'info',
          statusSwitch: '已删除'
        },
        4: {
          className: 'info',
          statusSwitch: '待完善'
        }
      },
      formInline: {
        activity_name: '',
        status: '0',
        dateRange: null,
        page: 1,
        page_size: 20
      },
      activeIndex: '-1',
      list: [],
      total_count: 0,
      loading: false,
      dialogVisible: false,
      share_qrcode: '',
      shareActivityVisible: false,
      postActivityVisible: false,
      shareActivityData: [false, { text: '' }],
      postActivityData: [false, { text: '' }]
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      if (this.formInline.dateRange) {
        this.formInline.start_time = moment(this.formInline.dateRange[0]).format('YYYY-MM-DD')
        this.formInline.end_time = moment(this.formInline.dateRange[1]).format('YYYY-MM-DD')
      } else {
        this.formInline.start_time = null
        this.formInline.end_time = null
      }
      if (this.activeIndex !== '-1') {
        this.formInline.status = this.activeIndex
      } else {
        this.formInline.status = null
      }
      const data = await this.$api.formActivity.getFormsActivityList(this.formInline)
      if (data) {
        data.list.forEach((v) => {
          v.isShowCode = false
        })
        this.list = data.list
        this.total_count = data.total_count
      }
    },
    onSubmit () {
      this.formInline.page = 1
      this.getList()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 列表分页
    handleSizeChange (val) {
      this.formInline.page = 1
      this.formInline.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    showCode (val) {
      this.list.forEach((v) => {
        v.isShowCode = false
      })
      val.isShowCode = true
      this.share_qrcode = val.share_qrcode
      // this.dialogVisible = true
    },
    hideCode (val) {
      val.isShowCode = false
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    handleJumpNew (value) {
      this.$router.push({ path: `/drainage/formActivity/new/${value || 0}` })
    },
    handleJumpData (value) {
      this.$router.push({ path: `/drainage/formActivity/data/${value || 0}` })
    },
    shareActivityVisibleChange (value) {
      if (value[0] === false) {
        this.shareActivityVisible = false
      }
      if (value[1]) {
        this.shareActivityData = value
        this.getList()
      }
    },
    postActivityVisibleChange (value) {
      if (value[0] === false) {
        this.postActivityVisible = false
      }
      if (value[1]) {
        this.postActivityData = value
        this.getList()
      }
    },
    handleShare (item) {
      this.list.forEach((v) => {
        v.isShowCode = false
      })
      this.shareActivityVisible = true
      this.shareActivityData = [true, { item }]
    },
    async handleCopy (item) {
      this.$confirm('请确认是否要复制?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const params = item.activity_id
          const data = await this.$api.formActivity.copyFormsActivity({ activity_id: params })
          if (data.status === true) {
            this.$message({
              message: '复制成功',
              type: 'success'
            })
            this.getList()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    async handleDelete (item) {
      const params = item.activity_id
      const data = await this.$api.formActivity.removeFormsActivity({ activity_id: params })
      if (data.status === true) {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.getList()
      }
    },
    async handleEnd (item) {
      this.$confirm('请确认是否立即结束?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const params = item.activity_id
          const data = await this.$api.formActivity.endFormsActivity({ activity_id: params })
          if (data.status === true) {
            this.$message({
              message: '结束成功',
              type: 'success'
            })
            this.getList()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    handleSelect () {
      this.getList()
    },
    handlePost (item) {
      this.postActivityVisible = true
      this.postActivityData = [true, { item }]
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.time {
  width: 100%;
  background-color: rgb(190, 186, 186, 0.7);
  color: #fff;
  text-align: center;
  position: relative;
  // margin-top: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mb10 {
  margin-bottom: 25px;
}
.content {
  position: relative;
}
.image-box {
  width: 100%;
  height: 160px;

  // height: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.hover-content {
  width: 100%;
  // height: 51%;
  font-size: 50px;
  background-color: rgb(190, 186, 186, 0.4);
  padding-top: 30%;
  position: absolute;
  top: 0;
  right: 0;
  // z-index: 999;
  display: none;
  cursor: pointer;
  color: #fff;
}
.content:hover .hover-content {
  display: block;
}
.over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 45px;
}
.status {
  padding: 5px;
  // position: absolute;
  // top: 0%;
  // color: #fff;
  // padding: 6px 16px;
  // border-radius: 0 0 30px 0;
}
.block {
  width: 100% !important;
}
.button_border {
  border: 1px solid #ddd;
  border-left: none;
  border-right: none;
  cursor: pointer;
}
.mid {
  padding: 10px;
}
.el-form {
  margin-bottom: -28px !important;
}
// @media screen and (min-width: 800px) {
//   .image-box {
//     width: 100%;

//     height: 128px;
//   }
//   .hover-content {
//     height: 128px;
//   }
// }
// @media screen and (min-width: 1200px) {
//   .image-box {
//     width: 100%;

//     height: 200px;
//   }
//   .hover-content {
//     height: 200px;
//   }
// }
// @media screen and (min-width: 1600px) {
//   .image-box {
//     width: 100%;

//     height: 300px;
//   }
//   .hover-content {
//     height: 300px;
//   }
// }
// .end {
//   // background: linear-gradient(307deg, #e56060 0%, #c80000 100%);
//   // box-shadow: 0px 2px 10px 0px rgba(163, 177, 191, 0.5), 0px 0px 11px 0px rgba(0, 0, 0, 0.21);
//   // border-radius: 2px 0px 16px 0px;
//   background: #c80000;
//   color: white;
// }
.pending {
  // background: linear-gradient(308deg, #12e2e9 0%, #60a3ef 100%);
  // box-shadow: 0px 2px 10px 0px rgba(163, 177, 191, 0.5), 0px 0px 11px 0px rgba(0, 0, 0, 0.21);
  // border-radius: 2px 0px 16px 0px;
  background: #60a3ef;
}
.activated {
  // background: linear-gradient(270deg, #71d8a6 0%, #32b175 100%);
  // box-shadow: 0px 2px 10px 0px rgba(163, 177, 191, 0.5), 0px 0px 11px 0px rgba(0, 0, 0, 0.21);
  // border-radius: 2px 0px 16px 0px;
  background: #32b175;
}
.card {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.tips {
  text-align: center;
  font-size: 12px;
  margin: 15px;
}
.red {
  color: red;
}
.tac {
  text-align: center;
  margin: 0 auto;
  color: #999;
  font-size: 12px;
  font-weight: normal;
}
.tal {
  text-align: left;
  margin: 0 auto;
  color: #999;
  font-size: 12px;
  font-weight: normal;
}
.no-data {
  position: relative;
  left: 880%;
}
.title {
  display: -webkit-box;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  line-height: 1.3;
  height: 40px;
  font-size: 14px;
  color: #666;
  font-weight: normal;
}
.flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-view {
  padding-top: 1.5%;
  font-size: 26px;
}
.fs16 {
  font-size: 26px;
}
.code {
  min-height: 100px;
}
.status_info {
  display: flex;
  justify-content: space-between;
  min-height: 30px;
}
.preview {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  background: #fff;
  .preview-code {
    .close-btn {
      cursor: pointer;
      padding: 10px;
    }
    .code {
      width: 60%;
      height: 60%;
    }
  }
}
.end {
  position: relative;
  top: -5px;
  font-size: 12px;
  line-height: 30px;
  color: red;
}
.footer {
  display: flex;
  height: 35px;
  border-top: 1px solid #f8f8f8;
  .footer-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
    color: #999;
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 1px;
      background: #f8f8f8;
      content: '';
    }
    &:last-child::after {
      content: none;
    }
    &:hover {
      color: $dominant_hue;
    }
    i {
      margin-right: 3px;
      vertical-align: middle;
      line-height: 1;
      font-size: 10px;
    }
  }
}
.join {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
  height: 15px;
}
.long_term {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
